import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    html: '',
    css: '',
    js: '',
    actions: [] as any[],
    prompt: '',
    schemaJson: null as string | null,
    schema: null as any,
    heading: {} as Record<string, any>,
  },

  blockDesign: {} as Record<string, any>,
  containerDesign: {} as Record<string, any>,
};

export const aiAppSlice = createSlice({
  name: 'custom',
  initialState,
  reducers: {
    aiAppStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.blockContent = {
        html: blockContent?.html ?? '',
        css: blockContent?.css ?? '',
        js: blockContent?.js ?? '',
        actions: blockContent?.actions ?? [],
        prompt: blockContent?.prompt ?? '',
        schemaJson: blockContent?.schemaJson ?? null,
        schema: blockContent?.schemaJson ? (() => { try { return JSON.parse(blockContent.schemaJson); } catch { return null; } })() : null,
        heading: blockContent?.heading ?? {},
      };

      state.containerDesign = containerDesign ?? {};
      state.blockDesign = blockDesign ?? {};
    },

    aiAppClear: () => initialState,

    aiAppUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    aiAppUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },

    aiAppUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },

    aiAppUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
  },
});

export const selectAiAppId = (state: any) => state.custom.id;
export const selectAiAppUID = (state: any) => state.custom.uid;
export const selectAiAppSID = (state: any) => state.custom.sid;
export const selectAiAppIsLoading = (state: any) => state.custom.isLoading;
export const selectAiAppBlockContent = (state: any) => state.custom.blockContent;
export const selectAiAppBlockDesign = (state: any) => state.custom.blockDesign;
export const selectAiAppContainerDesign = (state: any) => state.custom.containerDesign;

export const { aiAppStore, aiAppClear, aiAppUpdateIsLoading, aiAppUpdateBlockContent, aiAppUpdateBlockDesign, aiAppUpdateIsActive } = aiAppSlice.actions;

export default aiAppSlice.reducer;
